<template>
  <div class="add-speaker">
    <HseHeading size="h3">{{
      $t(this.speaker ? "headings.editableSpeaker" : "headings.addSpeaker")
    }}</HseHeading>
    <HseSpace size="small" vertical />
    <div v-show="isCheckExists" class="check">
      <div class="field">
        <Validator :field="fields.email" @change="toggleError" />
        <HseSpace size="small_2x" vertical />
      </div>

      <div class="form-footer">
        <div class="actions">
          <HseButton
            v-on:click="checkEmail"
            :spinner="buttonSpinner"
            spinnerPosition="left"
          >
            <span v-if="buttonSpinner === false">{{
              $t("headings.addSpeaker")
            }}</span>
            <span v-else-if="buttonSpinner === true"
              >{{ $t("adding") }}...</span
            >
            <span v-else-if="buttonSpinner === 'done'">{{
              $t("auth.btnDone")
            }}</span>
          </HseButton>
        </div>
        <div class="form-description">{{ $t("fields.requiredFields") }}</div>
      </div>
    </div>
    <div v-show="!isCheckExists" class="the-form">
      <div class="subheading">{{ $t("headings.personal") }}</div>
      <HseSpace size="small" vertical />
      <div class="form">
        <div v-if="isLangRu" class="field">
          <Validator :field="fields.lastName" />
          <HseSpace size="small_2x" vertical />
        </div>
        <div class="field">
          <Validator :field="fields.lastNameEn" />
          <HseSpace size="small_2x" vertical />
        </div>
        <div v-if="isLangRu" class="field">
          <Validator :field="fields.firstName" />
          <HseSpace size="small_2x" vertical />
        </div>
        <div class="field">
          <Validator :field="fields.firstNameEn" />
          <HseSpace size="small_2x" vertical />
        </div>
        <div v-if="isLangRu" class="field">
          <Validator :field="fields.secondName" />
          <HseSpace size="small_2x" vertical />
        </div>
        <div class="field">
          <Validator :field="fields.countryId" />
          <HseSpace size="small_2x" vertical />
        </div>
        <div class="field">
          <Validator :field="fields.email" @change="toggleError" />
        </div>
        <!-- <div class="cols">
          <div class="field fileUploader_item">
            <HseSpace size="small" vertical />
            <FileUploader :field="fields.Passport" />
          </div>
        </div> -->
      </div>

      <div class="subheading">{{ $t("headings.company") }}</div>
      <HseSpace size="small" vertical />
      <div class="form">
        <div class="field">
          <Validator @change="setAffiliated" :field="fields.HSEMember" />
          <HseSpace size="small_2x" vertical />
        </div>
        <div class="field"></div>
        <div class="field" v-show="fields.HSEMember.value">
          <Validator :field="fields.campusId" @change="setCampus" />
          <HseSpace size="small_2x" vertical />
        </div>
      </div>
      <div class="form">
        <div v-if="isLangRu" class="field">
          <Validator :field="fields.organizationName" />
          <HseSpace size="small_2x" vertical />
        </div>
        <div class="field">
          <Validator :field="fields.organizationNameEn" />
          <HseSpace size="small_2x" vertical />
        </div>
      </div>
      <!-- <div class="form">
        <div class="field">
          <Validator @change="setAffiliated" :field="fields.HSEMember" />
          <HseSpace size='small_2x' vertical />
        </div>
        <div class="field"></div>
        <div class="field" v-show="fields.HSEMember.value">
          <Validator :field="fields.campusId" @change="setCampus" />
          <HseSpace size='small_2x' vertical />
        </div>
      </div> -->
      <RadioGroup
        v-if="isMixed"
        :label="$t('participationFormatId')"
        :options="fields.participationFormatId.options"
        @change="setFormat"
        :defaultValue="fields.participationFormatId.value"
      />
      <HseSpace size="medium" vertical />
      <div class="form-footer">
        <div class="actions">
          <HseButton
            v-on:click="registerReq"
            :spinner="buttonSpinner"
            spinnerPosition="left"
          >
            <span v-if="buttonSpinner === false">{{
              $t(this.speaker ? "save" : "headings.addSpeaker")
            }}</span>
            <span v-else-if="buttonSpinner === true"
              >{{ $t(this.speaker ? "saving" : "adding") }}...</span
            >
            <span v-else-if="buttonSpinner === 'done'">{{
              $t("auth.btnDone")
            }}</span>
          </HseButton>
        </div>
        <div class="form-description">{{ $t("fields.requiredFields") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { HseHeading, HseSpace, HseButton } from "@hse-design/vue";
import { api } from "../../api";
import Validator from "../common/form/Validator.vue";
import RadioGroup from "../common/form/RadioGroup.vue";
import fields from "./speakerFields1";
import { resourceLoader } from "../common/resourceLoader";
import { mapState } from "vuex";
import { localizeFields } from "../../i18n";

export default {
  components: {
    HseHeading,
    HseSpace,
    HseButton,
    Validator,
    RadioGroup,
  },
  props: ["editableSpeaker", "added", "orgFormat", "showFormat"],
  data: () => ({
    fields,
    buttonSpinner: false,
    isCheckExists: true,
    campus: { en: [], ru: [] },
    speaker: null,
    userId: "",
    compareRuEnFields: {
      lastName: "lastNameEn",
      firstName: "firstNameEn",
      organizationName: "organizationNameEn",
    },
    enabledFields: [
      "HSEMember",
      "countryId",
      "organizationName",
      "organizationNameEn",
      "campusId",
    ],
  }),
  created() {
    ["en", "ru"].forEach((lang) =>
      resourceLoader
        .load("campusList", { lang })
        .then((data) => (this.campus[lang] = data))
    );
    this.translateFields();
    this.fields.participationFormatId.getAllOptions();
    if (this.editableSpeaker) {
      this.speaker = this.editableSpeaker;
      this.fillFields(this.speaker);
    }
  },
  computed: {
    isLangRu() {
      return this.lang === "ru";
    },
    isMixed() {
      return this.orgFormat === "895BB6AB-A343-48DC-AA19-7EAB348C8C0D";
    },
    isMoscowCampus() {
      return (
        this.fields.campusId.value === "DFA00199-FB13-47BB-A69B-F01C6F525F71"
      );
    },
    ...mapState(["lang"]),
  },
  watch: {
    lang() {
      this.translateFields();
    },
  },
  methods: {
    setFormat(val) {
      this.fields.participationFormatId.setValues(true, val);
    },
    setAffiliated() {
      if (!this.fields.HSEMember.value) {
        this.fields.organizationName.value = "";
        this.fields.organizationNameEn.value = "";
      }
    },
    setCampus(campus) {
      const currCampus = this.campus.ru.find((cmps) => cmps.value === campus);
      const currCampusEn = this.campus.en.find((cmps) => cmps.value === campus);

      if (currCampus)
        this.fields.organizationName.setValues(
          true,
          `НИУ ВШЭ${this.isMoscowCampus ? "" : ` - ${currCampus.label}`}`
        );

      if (currCampusEn)
        this.fields.organizationNameEn.setValues(
          true,
          `HSE University${
            this.isMoscowCampus ? "" : ` - ${currCampusEn.label}`
          }`
        );
    },
    toggleError(value) {
      const isErrSet =
        this.$store.state.error && this.$store.state.error.code === 876;
      const isAdded = this.added.some((coauth) => coauth.email === value);
      if (isAdded && !isErrSet) {
        if (this.editableSpeaker && this.editableSpeaker.email === value)
          return;
        this.$store.commit("setError", { code: 876 });
        this.$emit("validateFields");
      } else if (!isAdded && isErrSet) {
        this.$store.commit("setError", null);
        this.$emit("validateFields");
      }
    },
    translateFields() {
      this.fields = localizeFields(fields, this.fields);
    },
    registerReq() {
      this.$emit("validateFields");
      let isFormInvalid = false;
      const skip = this.isLangRu ? [] : Object.keys(this.compareRuEnFields);

      isFormInvalid =Object.keys(this.fields).some((key) => {
        if (
          (!this.fields.HSEMember.value && key === "campusId") ||
          skip.includes(key)
        )
          return false;
        // if (key != "Passport") {
        //   isFormInvalid = this.fields[key].isValid === false;
        // }
        return this.fields[key].isValid === false;
      });

      if (isFormInvalid) return;

      this.buttonSpinner = true;
      const params = {
        lastName:
          this.lang === "ru"
            ? this.fields.lastName.value
            : this.fields.lastNameEn.value,
        firstName:
          this.lang === "ru"
            ? this.fields.firstName.value
            : this.fields.firstNameEn.value,
        secondName: this.fields.secondName.value,
        lastNameEn: this.fields.lastNameEn.value,
        firstNameEn: this.fields.firstNameEn.value,
        email: this.fields.email.value,
        organizationName:
          this.lang === "ru"
            ? this.fields.organizationName.value
            : this.fields.organizationNameEn.value,
        organizationNameEn: this.fields.organizationNameEn.value,
        HSEMember: this.fields.HSEMember.value,
        campusId:
          this.fields.campusId.value === "" ? null : this.fields.campusId.value,
        countryId:
          this.fields.countryId.value === ""
            ? null
            : this.fields.countryId.value,
        participationFormatId: this.fields.participationFormatId.value,
        PassportId: "",
      };
      if (this.isMixed) {
        params.participationFormatId = this.fields.participationFormatId.value;
      } else {
        params.participationFormatId = this.orgFormat;
      }
      if (this.speaker && this.speaker.id !== this.userId) {
        params.id = this.speaker.id ?? null;
      }
      this.buttonSpinner = "done";
      setTimeout(() => {
        this.buttonSpinner = false;
        this.$emit("saved", params);
      }, 2000);
      return;
    },
    checkEmail() {
      this.$emit("validateFields");

      if (this.fields.email.isValid) {
        this.buttonSpinner = true;

        api
          .auth("user.manage.check.login", this.fields.email.value)
          .then((result) => {
            if (result) {
              this.userId = result;
              const isAdded = this.added.some((item) => item.id === result);
              if (!isAdded) {
                api.auth("user.manage.get", result).then((data) => {
                  this.speaker = data;
                  this.fillFields(data);
                  this.buttonSpinner = false;
                });
              } else {
                this.$store.commit("setError", { code: 876 });
                this.buttonSpinner = false;
                this.$emit("validateFields");
              }
            } else {
              this.buttonSpinner = false;
              this.isCheckExists = false;
            }
          });
      }
    },
    fillFields(userData) {
      this.isCheckExists = false;
      const uData = this.editableSpeaker ? userData : userData.data.public;
      const fieldsKeys = Object.keys(this.fields);
      this.fields.lastName.setValues(true, uData.LName);
      this.fields.lastNameEn.setValues(true, uData.LNameEN);
      this.fields.firstName.setValues(true, uData.FName);
      this.fields.firstNameEn.setValues(true, uData.FNameEN);
      this.fields.secondName.setValues(true, uData.SName);
      fieldsKeys.forEach((key) => {
        if (uData[key]) this.fields[key].setValues(true, uData[key]);
      });
      if (this.speaker && !this.speaker.isNew && this.editableSpeaker) {
        this.fields.organizationName.setValues(
          true,
          this.editableSpeaker.organizationName
        );
        this.fields.organizationNameEn.setValues(
          true,
          this.editableSpeaker.organizationNameEn
        );
        this.fields.HSEMember.setValues(true, this.editableSpeaker.HSEMember);
        this.fields.campusId.setValues(true, this.editableSpeaker.campusId);
        this.fields.countryId.setValues(true, this.editableSpeaker.countryId);
        // this.fields.Passport.setValues(true, this.editableSpeaker.countryId);
        if (this.editableSpeaker.participationFormatId) {
          this.fields.participationFormatId.setValues(
            true,
            this.editableSpeaker.participationFormatId
          );
        }
      }
      this.fields.email.setValues(true, userData.login ?? userData.email);
      if (!userData.isNew) {
        fieldsKeys.forEach((key) => {
          if (!this.enabledFields.includes(key)) {
            this.fields[key]["disabled"] = true;
          }
        });
      } else this.$emit("validateFields");
    },
  },
  i18n: {
    messages: {
      en: {
        headings: {
          addSpeaker: "Add a speaker",
          editableSpeaker: "Edit a speaker",
          personal: "Personal details",
          company: "Company",
        },
        adding: "Adding",
        offline: "Offline",
        online: "Online",
        mixed: "Mixed",
        participationFormatId: "Participation format",
      },
      ru: {
        headings: {
          addSpeaker: "Добавить эксперта",
          editableSpeaker: "Редактировать эксперта",
          personal: "Личная информация",
          company: "Организация",
        },
        adding: "Добавляем",
        offline: "Офлайн",
        online: "Онлайн",
        mixed: "Смешанный",
        participationFormatId: "Формат участия",
      },
    },
  },
};
</script>

<style scoped>
.add-speaker .form {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -16px;
}
.form.down {
  align-items: flex-end;
}
.form .field {
  padding: 0 16px;
  min-width: 0;
  width: 50%;
  flex-basis: 50%;
}
.actions .hse-Button {
  display: inline-block;
}
.checkboxes {
  display: flex;
  justify-content: space-between;
}
.form-footer {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.form-description {
  padding-top: 12px;
  font-size: 14px;
  line-height: 20px;
  color: #6b7a99;
}
.flex-tooltip {
  display: flex;
}
.flex-tooltip > div:first-child {
  width: calc(100% - 28px);
}
.flex-tooltip > div:last-child {
  padding: 36px 0 0 12px;
}
@media (max-width: 1024px) {
  .register {
    margin: 16px auto;
    max-width: 95%;
  }
  .emptyfield {
    display: none;
  }
  .checkboxes {
    flex-direction: column;
  }
}
@media (max-width: 768px) {
  .form .field {
    width: 100%;
    flex-basis: 100%;
  }
  .form-footer {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
<style>
.smallLabel {
  font-size: 14px !important;
}
@media (max-width: 768px) {
  .hse-Input_disabled input:disabled {
    opacity: 1 !important;
    color: #000 !important;
  }
}
</style>
